/**
 * The product name, in ONE place.
 *
 * Translated copy must never hard-code it: PR #563 took "Trusted Helpers" from
 * 5 to 22 occurrences across 5 locale blocks, several mid-sentence in Arabic
 * and Swahili. A rebrand (#558) would then have to be resolved by hand in
 * every locale — and whoever resolved it would have to spot strings their
 * branch had never seen. Copy uses the `{brand}` token instead; `t()`
 * interpolates it automatically.
 *
 * A brand name is not translatable, so this is deliberately not in
 * translations.ts.
 */
export const BRAND_NAME = 'Kanfy';
